import { useDispatch, useSelector } from 'react-redux';
import { useEffectOnce } from 'usehooks-ts';

import { useRouteParam } from '@hooks/params';

import { selectHealthQuotePaymentPage } from './selector';
import {
  healthQuoteFetch,
  HealthQuoteFetchPayload,
  billingFetch,
  BillingFetchPayload,
} from './action';

export const useHealthQuoteFetch = () => {
  const orderNumber = useRouteParam('orderNumber') as string;
  const dispatch = useDispatch();
  const { healthQuote } = useSelector(selectHealthQuotePaymentPage);
  useEffectOnce(() => {
    const payload: HealthQuoteFetchPayload = { orderNumber };
    dispatch(healthQuoteFetch(payload));
  });
  return healthQuote;
};


export const useBillingFetch = () => {
  const dispatch = useDispatch();
  const billingId = Number(useRouteParam('billingId'));
  const { billing } = useSelector(selectHealthQuotePaymentPage);
  useEffectOnce(() => {
    const payload: BillingFetchPayload = { id: billingId };
    dispatch(billingFetch(payload));
  });
  return billing;
};
